import { IConveyorBox, IConveyorBoxUI } from "../../interfaces/ConveyorBox/IConveyorBox";
import { CancellationReason } from "../../rxAutoMessages/rxAutoMessages";
import { ISortBoxItemModel } from "../../SortBoxItem/ISortBoxItemModel";
import { RootState } from "../storeConfig";
import { IPayloadWrapper } from "../types/PayloadWrapper";

/**
 * -------------------------------------
 * Action Types definition
 * -------------------------------------
 * */
export const SET_CONVEYOR_BOX = "automatpacken/reviewbox/SET_CONVEYOR_BOX";
export const CLEAR_CONVEYOR = "automatpacken/reviewbox/CLEAR";
export const FETCH_CONVEYOR_BOX = "automatpacken/reviewbox/FETCH_CONVEYOR_BOX";
export const REFRESH_CONVEYOR_BOX = "automatpacken/reviewbox/REFRESH_CONVEYOR_BOX";
export const UPDATE_BOX_BARCODE = "automatpacken/reviewbox/UPDATE_BOX_BARCODE";
export const TRIGGER_POST_PICK = "automatpacken/reviewbox/TRIGGER_POST_PICK";
export const TRIGGER_BATCH_PICK = "automatpacken/reviewbox/TRIGGER_BATCH_PICK";
export const FINISH_SKU_PUTAWAY = "automatpacken/reviewbox/FINISH_SKU_PUTAWAY";
export const VERIFY_BOX_ITEM = "automatpacken/reviewbox/VERIFY_BOX_ITEM";
export const RESET_ALL_VERIFIED_ITEM_QUANTITY =
  "automatpacken/reviewbox/RESET_ALL_VERIFIED_ITEM_QUANTITY";
export const AUTO_VERIFY_ALL_ITEMS = "automatpacken/reviewbox/AUTO_VERIFY_ALL_ITEMS";
export const AUTO_VERIFY_QUANTITY = "automatpacken/reviewbox/AUTO_VERIFY_QUANTITY";
export const UPDATE_BOX_ITEMS = "automatpacken/reviewbox/UPDATE_BOX_ITEMS";
export const LOAD_IPACK_IMAGES = "automatpacken/conveyorbox/LOAD_IPACK_IMAGES";
export const SET_IMAGE_DATA = "automatpacken/conveyorbox/SET_IMAGE_DATA";
export const SET_STOCK = "automatpacken/conveyorbox/SET_STOCK";
export const RELOCATE_BOX = "automatpacken/conveyorbox/RELOCATE_BOX";
export const CANCEL_ORDER = "automatpacken/conveyorbox/CANCEL_ORDER";
export const REQUEST_NEW_SHIPPING_LABEL = "automatpacken/conveyorbox/REQUEST_NEW_SHIPPING_LABEL";
export const REQUEST_NEW_SHIPPING_LABEL_FAILED =
  "automatpacken/conveyorbox/REQUEST_NEW_SHIPPING_LABEL_FAILED";
export const PRINT_NEW_LABEL = "automatpacken/conveyorbox/PRINT_NEW_LABEL";
export const CHANGE_SHIPPING_LABEL_TO_POSTEN =
  "automatpacken/conveyorbox/CHANGE_SHIPPING_LABEL_TO_POSTEN";

export const SET_IPACK_BOX_BARCODE_CONVEYOR =
  "automatpacken/reviewbox/SET_IPACK_BOX_BARCODE_CONVEYOR";
export const SET_ORDER_CHECKED = "automatpacken/reviewbox/SET_ORDER_CHECKED";
export const SET_ALL_SORTBOXITEMS = "automatpacken/reviewbox/SET_ALL_SORTBOXITEMS";
export const SET_AFRAME_SORTBOXITEMS = "automatpacken/reviewbox/SET_AFRAME_SORTBOXITEMS";
export const SET_MISSING_BOX_ITEM = "automatpacken/reviewbox/SET_MISSING_BOX_ITEM";
export const SET_BOX_AS_CONTROLLED = "automatpacken/reviewbox/SET_BOX_AS_CONTROLLED";
export const CONFIRM_ITEM_REMOVAL = "automatpacken/reviewbox/CONFIRM_ITEM_REMOVAL";
export const RESET_CURRENT_REVIEW = "automatpacken/reviewbox/RESET_CURRENT_REVIEW";
export const VERIFY_RX_BAGS_REQUIRED = "automatpacken/aFrameAppMode/VERIFY_RX_BAGS_REQUIRED";
export const SET_VERIFIED_RX_BAGS_EAN = "automatpacken/aFrameAppMode/SET_VERIFIED_RX_BAGS_EAN";
export const SET_CONFIRM_WRONG_RX_BAG_SCAN =
  "automatpacken/aFrameAppMode/SET_CONFIRM_WRONG_RX_BAG_SCAN";
export const CONFIRM_VERIFY_PICK_FINISHED = "automatpacken/reviewbox/CONFIRM_VERIFY_PICK_FINISHED";
export const UNVERIFY_BOX_ITEM = "automatpacken/reviewbox/UNVERIFY_BOX_ITEM";
// export const setConfirmWrongRxBagScan = (payload: IPayloadWrapper<string[]>) => {
//   return {
//     type: SET_CONFIRM_WRONG_RX_BAG_SCAN,
//     payload,
//   };
// };

// export const setVerifiedRxBagsEAN = (payload: IPayloadWrapper<string[]>) => {
//   return {
//     type: SET_VERIFIED_RX_BAGS_EAN,
//     payload,
//   };
// };

// export const verifyRxBagsRequired = (payload: IPayloadWrapper<boolean>) => {
//   return {
//     type: VERIFY_RX_BAGS_REQUIRED,
//     payload,
//   };
// };
/**
 * -------------------------------------
 * Action Creator definitions
 * -------------------------------------
 * */
export const setConveyorBoxData = (payload: { conveyorBoxReview: any }) => {
  return {
    type: SET_CONVEYOR_BOX,
    payload,
  };
};

export const clearReviewBoxData = () => {
  return {
    type: CLEAR_CONVEYOR,
  };
};

export const loadIPackImages = () => {
  return {
    type: LOAD_IPACK_IMAGES,
  };
};

export const setImageData = (payload: { imageBytes: any; imageFound: boolean }) => {
  return {
    type: SET_IMAGE_DATA,
    payload,
  };
};

export const setStock = (payload: { data: any }) => {
  return {
    type: SET_STOCK,
    payload,
  };
};

export const fetchConveyorBox = (payload: {
  type: number;
  input: string;
  errorCallback?: (message: string) => void;
  callbackFn?: () => void;
}) => {
  return {
    type: FETCH_CONVEYOR_BOX,
    payload,
  };
};

export const refreshConveyorBox = (payload: { callbackFn: () => void }) => {
  return {
    type: REFRESH_CONVEYOR_BOX,
    payload,
  };
};

export const updateBoxBarcode = (payload: {
  currentBarcode: string;
  newBarcode: string;
  selectedBoxSize: string;
}) => {
  return { type: UPDATE_BOX_BARCODE, payload };
};
export const relocateBox = () => {
  return { type: RELOCATE_BOX };
};

export const cancelOrder = () => {
  return { type: CANCEL_ORDER };
};

export const setIPackBoxBarcode = (payload: IPayloadWrapper<string>) => {
  return {
    type: SET_IPACK_BOX_BARCODE_CONVEYOR,
    payload,
  };
};

export const updateBoxItems = (payload: IPayloadWrapper<{ active: any[]; cancelled: any[] }>) => {
  return {
    type: UPDATE_BOX_ITEMS,
    payload,
  };
};

export const triggerPostPick = () => {
  return {
    type: TRIGGER_POST_PICK,
  };
};

export const triggerBatchPick = () => {
  return {
    type: TRIGGER_BATCH_PICK,
  };
};

export const finishSkuPutaway = (payload: any) => {
  return {
    type: FINISH_SKU_PUTAWAY,
    payload,
  };
};

export const verifyBoxItem = (payload: any) => {
  return {
    type: VERIFY_BOX_ITEM,
    payload,
  };
};

export const unverifyBoxItem = (payload: any) => ({
  type: UNVERIFY_BOX_ITEM,
  payload,
});

export const autoVerifyAllItems = () => {
  return {
    type: AUTO_VERIFY_ALL_ITEMS,
  };
};

export const autoVerifyQuantity = (payload: any) => {
  return {
    type: AUTO_VERIFY_QUANTITY,
    payload,
  };
};

export const resetAllVerifiedItemQuantity = () => {
  return {
    type: RESET_ALL_VERIFIED_ITEM_QUANTITY,
  };
};

export const confirmItemRemoval = (payload: any) => {
  return {
    type: CONFIRM_ITEM_REMOVAL,
    payload,
  };
};

export const setOrderChecked = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_ORDER_CHECKED,
    payload,
  };
};

export const setAllSortboxItems = (payload: IPayloadWrapper<ISortBoxItemModel>) => {
  return {
    type: SET_ALL_SORTBOXITEMS,
    payload,
  };
};

export const setAframeSortboxItems = (payload: IPayloadWrapper<ISortBoxItemModel>) => {
  return {
    type: SET_AFRAME_SORTBOXITEMS,
    payload,
  };
};

export const setMissingBoxItem = (payload: any) => {
  return {
    type: SET_MISSING_BOX_ITEM,
    payload,
  };
};

export const setBoxAsControlled = () => {
  return {
    type: SET_BOX_AS_CONTROLLED,
  };
};

export const resetCurrentReview = () => {
  return {
    type: RESET_CURRENT_REVIEW,
  };
};

export const requestNewShippingLabel = () => {
  return {
    type: REQUEST_NEW_SHIPPING_LABEL,
  };
};
export const requestNewShippingLabelFailed = () => {
  return {
    type: REQUEST_NEW_SHIPPING_LABEL_FAILED,
  };
};
export const changeLabelInAutomation = () => {
  return {
    type: CHANGE_SHIPPING_LABEL_TO_POSTEN,
  };
};

export const printNewLabel = () => {
  return {
    type: PRINT_NEW_LABEL,
    requestNewShippingLabelFailed: false,
  };
};

export const confirmVerifyPickFinished = () => {
  return {
    type: CONFIRM_VERIFY_PICK_FINISHED,
  };
};

const initialState: IConveyorBoxUI = {
  stock: [],
  orderNumber: -1,
  iPackBoxID: -1,
  boxBarcode: "",
  vendor: {
    companyId: -1,
    shopId: -1,
  },
  shipping: {
    id: -1,
    weight: 0,
    iPackMeasuredWeight: 0,
    status: -1,
    packageNumber: "",
    shippingMethod: -1,
    latestShippingTime: "1950-01-01T00:00:00",
    shippingAddressFormatted: "",
  },
  items: {
    active: [],
    cancelled: [],
  },
  warnings: [],
  validationResult: -1,
  requestNewShippingLabelFailed: false,
  // missingBoxItem: null,
  // warningMessage: null,
  // verifyRxBagsRequired: false,
  // verifiedRxBagsEan: [],
  // confirmWrongRXScan: false,
};
/**
 * -------------------------------------
 * Reducer definition
 * -------------------------------------
 * */
const conveyorBoxReviewReducer = (state = { ...initialState }, action: any) => {
  switch (action.type) {
    case SET_CONVEYOR_BOX:
      return { ...state, ...action.payload.conveyorBoxReview };

    case REQUEST_NEW_SHIPPING_LABEL:
      return {
        ...state,
        requestNewShippingLabelFailed: false,
      };
    case REQUEST_NEW_SHIPPING_LABEL_FAILED:
      return {
        ...state,
        requestNewShippingLabelFailed: true,
      };
    case PRINT_NEW_LABEL:
      return {
        ...state,
        requestNewShippingLabelFailed: false,
      };
    case CHANGE_SHIPPING_LABEL_TO_POSTEN:
      return {
        ...state,
        requestNewShippingLabelFailed: false,
      };

    case VERIFY_BOX_ITEM: {
      const updatedItems = state.items.active.map((item) => {
        if (item.id === action.payload.value) {
          item.verifiedQuantity += 1;
        }
        return item;
      });
      return {
        ...state,
        items: { ...state.items, active: updatedItems },
      };
    }
    case AUTO_VERIFY_ALL_ITEMS: {
      const updatedItems = state.items.active.map((item) => {
        item.verifiedQuantity = item.pickedQuantity;
        return item;
      });
      return {
        ...state,
        items: { ...state.items, active: updatedItems },
      };
    }
    case AUTO_VERIFY_QUANTITY: {
      const updatedItems = state.items.active.map((item) => {
        if (item.id === action.payload.value) {
          item.verifiedQuantity = item.pickedQuantity;
        }
        return item;
      });
      return {
        ...state,
        items: { ...state.items, active: updatedItems },
      };
    }
    case RESET_ALL_VERIFIED_ITEM_QUANTITY: {
      const updatedItems = state.items.active.map((item) => {
        item.verifiedQuantity = 0;
        return item;
      });
      return {
        ...state,
        items: { ...state.items, active: updatedItems },
      };
    }
    case CLEAR_CONVEYOR:
      return { ...state, ...initialState };
    case SET_IPACK_BOX_BARCODE_CONVEYOR:
      return {
        ...state,
        boxBarcode: action.payload.value,
      };
    // case SET_ORDER_CHECKED:
    //   return { ...state, orderChecked: action.payload.value };
    // case SET_ALL_SORTBOXITEMS:
    //   return { ...state, allSortBoxItems: action.payload.value };
    // case SET_AFRAME_SORTBOXITEMS:
    //   return { ...state, boxItems: action.payload.value };
    case SET_MISSING_BOX_ITEM:
      return {
        ...state,
        items: { active: action.payload.value, cancelled: state.items.cancelled },
      };
    case RESET_CURRENT_REVIEW:
      return { ...initialState };
    case UPDATE_BOX_ITEMS:
      return { ...state, items: action.payload.value };
    case SET_IMAGE_DATA:
      return {
        ...state,
        imageFound: action.payload.imageFound,
        imageBytes: action.payload.imageBytes,
      };
    case SET_STOCK:
      return {
        ...state,
        stock: action.payload.data,
      };
    case UNVERIFY_BOX_ITEM: {
      const updatedItems = state.items.active.map((item) => {
        if (item.id === action.payload.value && item.verifiedQuantity > 0) {
          item.verifiedQuantity -= 1;
        }
        return item;
      });
      return {
        ...state,
        items: { ...state.items, active: updatedItems },
      };
    }
    // case VERIFY_RX_BAGS_REQUIRED:
    //   return {
    //     ...state,
    //     verifyRxBagsRequired: action.payload.value,
    //     verifiedRxBagsEan: [],
    //     confirmWrongRXScan: false,
    //   };
    // case SET_VERIFIED_RX_BAGS_EAN:
    //   return { ...state, verifiedRxBagsEan: action.payload.value };
    // case SET_CONFIRM_WRONG_RX_BAG_SCAN:
    //   return { ...state, confirmWrongRXScan: action.payload.value };
    default:
      return state;
  }
};

// STATE SELECTORS
export const currentBoxSelector = (state: RootState): IConveyorBoxUI =>
  state.conveyorBoxReviewReducer;

/**
 * -------------------------------------
 * Public interface
 * -------------------------------------
 * */
export default conveyorBoxReviewReducer;
